<template>
  <span>{{ value }}</span>
</template>

<script>
import BaseControlMixin from '@/components/controls/mixins/BaseControl';
import { parseHMSFromSeconds, timerFormatted } from '@/utils/time';

const formats = {
  hh: value => [value.hours],
  'hh:mm': value => [value.hours, value.minutes],
  'hh:mm:ss': value => [value.hours, value.minutes, value.seconds],
};

function getTimerPartsByFormat(hms, format) {
  return formats[format || 'hh:mm:ss'](hms);
}

export default {
  name: 'TimerDisplayField',
  mixins: [
    BaseControlMixin,
  ],
  computed: {
    value() {
      const hms = parseHMSFromSeconds(Math.floor(this.getSingleVar.value / 1000));
      return timerFormatted(...getTimerPartsByFormat(hms, this.getSingleVar.format));
    },
  },
};
</script>

<style scoped>

</style>
